import gql from 'graphql-tag'

export default gql`
  fragment marketplaceCheckoutParcel on MarketplaceParcel {
    id
    fulfilmentType
    items {
      id
      sku
      variantGroupCode
      name
      image {
        url
        description
      }
      listPrice
      quantity
      optionValues {
        id
        optionId
        displayName
        value
      }
      shop {
        id
        name
      }
    }
    availableFulfilmentOptions {
      id
      type: fulfilmentType
      cost
      provider
      fulfilmentDayRange {
        min
        max
      }
      label
    }
    selectedFulfilmentOption {
      id
      type: fulfilmentType
      cost
      provider
      fulfilmentDayRange {
        min
        max
      }
      label
    }
  }
`
